export default "__VITE_ASSET__C5gG3LyQ__"